module.exports = __webpack_public_path__ + "img/291912_473531_3C2C25_3A2424-256px.3bd1a9bb.png";